import { useEffect } from "react";
import { brand } from "services/envService";

export const useFavIcon = () => {
  const BRAND = brand();
  useEffect(() => {
    let link = document.querySelector("link[rel*='icon']");
    link && link.setAttribute("href", `favicon_${BRAND}.ico`);
  }, [BRAND]);
};
